import { CaretLeftIcon } from "@phosphor-icons/react";
import { Button, ConfigProvider } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";

const BUTTON_WIDTH = 28;
const BUTTON_HEIGHT = 40;

type TabsCollapseButtonProps = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const TabsCollapseButton = ({ onClick }: TabsCollapseButtonProps) => {
  const { theme } = useAntTheme();
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorText: theme.colorText,
          },
        },
      }}
    >
      <Button
        icon={<CaretLeftIcon size={22} />}
        onClick={onClick}
        style={{
          border: "none",
          boxShadow: "none",
          width: BUTTON_WIDTH,
          height: BUTTON_HEIGHT,
          lineHeight: 1,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderTopRightRadius: theme.borderRadius,
          borderBottomRightRadius: theme.borderRadius,
        }}
      />
    </ConfigProvider>
  );
};
